import React, { useMemo } from 'react'

import {
  yerevanSlug,
  generatePath,
  yerevanAirportSlug,
  carRentalLocationsPath,
  internationalLocationsPath,
} from '@/utils'
import { IHomeType, IPageType } from '@/types'
import { Link } from '@/i18n'

export const DealsSection: React.FC<IPageType<IHomeType>> = ({ template }) => {
  const locations = useMemo(
    () => [
      {
        label: template.section_3_title_1,
        desc: template.section_3_description_1,
        path: generatePath(carRentalLocationsPath, undefined, [
          { location: yerevanSlug },
        ]),
      },
      {
        label: template.section_3_title_2,
        desc: template.section_3_description_2,
        path: generatePath(carRentalLocationsPath, {}, [
          { location: yerevanAirportSlug },
        ]),
      },
      {
        isExternal: true,
        path: internationalLocationsPath,
        label: template.section_3_title_3,
        desc: template.section_3_description_3,
      },
    ],
    [template],
  )
  return (
    <section className="deals padding-vertical--small theme--light-blue">
      <div className="row">
        <div className="column small-12">
          <div className="flex-container align-center">
            <div className="small-12 medium-6">
              <img
                title=""
                alt="content imagery illustration"
                src="/assets/img/content-imagery-illustration-deals@3x.jpg"
              />
            </div>
          </div>
          <div className="deals_header flex-container align-middle align-justify">
            <h2 className="white-color">{template.section_3_head}</h2>
          </div>
        </div>
        {locations.map(location => (
          <div key={location.path} className="column small-12 medium-4">
            <Link
              href={location.path}
              target={location.isExternal ? '_blank' : '_self'}
              className="deal_item display-block theme--white"
            >
              <p className="green-color">{location.label}</p>
              <p className="blue-color">{location.desc}</p>
            </Link>
          </div>
        ))}
      </div>
    </section>
  )
}
